import NetxQueryClient, {
	SuccessResponse,
} from '@netx/core-next/lib/queryClient';
export type {QueryError} from '@netx/core-next/lib/queryClient';
import {type ILabelValue} from '@netx/core-schema';
import {type IGroupAutoListItem} from '../schema';

/**
 * `getGroupAutoList` request params
 * (what is used to send to server)
 */
export interface GetGroupAutoListRequestOptions {
	query: string;
}

/**
 * `getGroupAutoList` request
 * (what gets sent to the server)
 */
export type GetGroupAutoListRequest = [GetGroupAutoListRequestOptions['query']];

/**
 * `getGroupAutoList` response
 * (what comes back from the server)
 */
export type GetGroupAutoListResponse = SuccessResponse<ILabelValue[]>;

/**
 * `getGroupAutoList` result
 * (what is utilized from the server response)
 */
export type GetGroupAutoListResult = IGroupAutoListItem[];

export const getGroupAutoListEndpoint = 'getGroupAutoList';

/**
 * Autolist groups
 * @param fetchParams Fetch params
 */
export const getGroupAutoList = async (
	{query}: GetGroupAutoListRequestOptions,
	signal?: AbortSignal,
) => {
	const client = NetxQueryClient();

	const requestParams: GetGroupAutoListRequest = [query];

	return client
		.post<GetGroupAutoListResponse>(getGroupAutoListEndpoint, requestParams, {
			signal,
		})
		.then((response) =>
			response.data.result.map<IGroupAutoListItem>((d) => ({
				...d,
				value: parseInt(d.value),
			})),
		);
};
export default getGroupAutoList;
